// test1024
(1024 && 0);
